<!-- =========================================================================================
    File Name: LockScreen.vue
    Description: Lock Screen Page
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter justify-center items-center">
        <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row no-gutter">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/lock-screen.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Login to Device</h4>
                                </div>
                                <vs-input icon-no-border icon="icon icon-user" icon-pack="feather" label-placeholder="Username" v-model="user" class="w-full mb-6"/>
                                <vs-input icon-no-border icon="icon icon-lock" icon-pack="feather" type="password" label-placeholder="Password" v-model="pass" class="w-full mb-6" />

                                <div class="flex justify-between flex-wrap">
                                    <router-link to="/login" class="mb-4">Login to Admin Portal ?</router-link>
                                    <vs-button class="ml-2" :disabled="!validateForm" @click="loginJWT">Unlock Device</vs-button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      user: '',
      pass: ''
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.user !== '' && this.pass !== ''
    }
  },
  methods: {
    loginJWT () {
      this.$vs.loading()
      this.$http.post('/auth/login', { user:this.user, password:this.pass })
        .then(({ data }) => {
          if (data.success) {
            this.$swal({
              title:`Welcome ${this.$store.state.AppActiveUser.displayName} !`,
              icon: 'success',
              timer: 1500,
              showConfirmButton: false
            })
            this.$vs.loading.close()
            if (data.user.center && data.user.center.website) window.location.href = data.user.center.website
            else this.$router.replace('/login')
          } else {
            this.$vs.notify({
              title: 'Login Failed',
              text: data.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              timer: 1500
            })
          }
        })
        .catch(e => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Failed to fetch data',
            text: e.response.data.message || e.message,
            iconPack: 'feather',
            icon: 'icon-x',
            color: 'danger',
            timer: 1500
          })
        })
    }
  }


}
</script>
